<template>
  <div v-show="isShowModal">
    <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/css/all.min.css"
      integrity="sha256-h20CPZ0QyXlBuAw7A+KluUYx/3pK+c7lYEpqLTlxjYQ="
      crossorigin="anonymous" />
    <div class="spx-modal h-100">
      <div class="spx-modal-body mx-auto">
        <div class="modal-header pt-0">
          <div class="justify-content-end" style="text-align-last: end">
            <button class="close" v-on:click="closeModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <!-- <h5 class="modal-title">{{ $t("share.Share") }}</h5> -->
          <h5 class="modal-title">Share</h5>
        </div>
        <div class="modal-body row pl-5 justify-content-center">
          <ShareNetwork
            class="col-5"
            v-for="network in networks"
            :network="network.network"
            :key="network.network"
            :style="{ backgroundColor: network.color }"
            :url="sharing.url"
            :title="sharing.title"
            :description="sharing.description"
            :quote="sharing.quote"
            :hashtags="sharing.hashtags"
            :twitterUser="sharing.twitterUser">
            <i :class="network.icon"></i>
            <span>{{ network.name }}</span>
          </ShareNetwork>
        </div>
        <div class="text-center">
          <button
            type="button"
            class="btn btn-outline-brand-1"
            v-on:click="copyToClipboard()">
            <!-- {{ $t("share.Copy_Link") }} -->
            Copy Profile Link
          </button>
        </div>
      </div>
    </div>
    <div class="spx-modal-background"></div>
  </div>
</template>

<script>
import ShareNetwork from "./share-network";
export default {
  name: "ShareModal",
  components: {
    ShareNetwork,
  },
  data() {
    return {
      isShowModal: false,
      sharing: {
        url: "https://news.vuejs.org/issues/180",
        title:
          "Say hi to Vite! A brand new, extremely fast development setup for Vue.",
        // description:
        //   'This week, I’d like to introduce you to "Vite", which means "Fast". It’s a brand new development setup created by Evan You.',
        // quote: "The hot reload is so fast it's near instant. - Evan You",
        // hashtags: "vuejs,vite,javascript",
        // twitterUser: "youyuxi",
      },
      networks: [
        {
          network: "facebook",
          // name: this?.$i18n?.t("share.Facebook"),
          name: 'Facebook',
          icon: "fab fah fa-lg fa-facebook-f",
          color: "#1877f2",
        },
        {
          network: "whatsapp",
          // name: this?.$i18n?.t("share.Whatsapp"),
          name: 'Whatsapp',
          icon: "fab fah fa-lg fa-whatsapp",
          color: "#25d366",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    showModal(url, title) {
      this.isShowModal = true;
      this.sharing.title = title;
      this.sharing.url = url;
    },
    closeModal() {
      this.isShowModal = false;
      this.removeLoader();
    },
    onClick() {
      this.$emit("remove", this.obj);
      this.showLoader = true;
    },
    removeLoader() {
      this.showLoader = false;
    },
    copyToClipboard() {
      let $this = this;
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(this.sharing.url).then(function () {
          $this.$notify({
            type: "success",
            text: $this.$i18n.t("share.Successfully copy to clipboard"),
            timeout: 200,
          });
        });
      }
    },
  },
};
</script>

<style>
body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}
h1 {
  text-align: center;
  margin: 50px 0 80px;
}
.share-network-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 1000px;
  margin: auto;
}
a[class^="share-network-"] {
  flex: none;
  color: #ffffff;
  background-color: #333;
  border-radius: 3px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  cursor: pointer;
  margin: 10px;
}
a[class^="share-network-"] .fah {
  background-color: rgba(0, 0, 0, 0.2);
  padding: 10px;
  flex: 0 1 auto;
}
a[class^="share-network-"] span {
  padding: 0 10px;
  flex: 1 1 0%;
  font-weight: 500;
}
</style>
